import { createAction } from 'redux-actions';

export default class Actions {

    static SET_LOADING = createAction("SET_LOADING");
    static UNSET_LOADING = createAction("UNSET_LOADING");

}